import { render } from "./user-password-change.vue?vue&type=template&id=17466e00&scoped=true"
import script from "./user-password-change.vue?vue&type=script&lang=js"
export * from "./user-password-change.vue?vue&type=script&lang=js"

import "./user-password-change.vue?vue&type=style&index=0&id=17466e00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17466e00"]])

export default __exports__